import AddIntake from "../../Components/Modals/AddIntake";
import AddScholarshipMapping from "../../Components/Modals/AddScholarshipMapping";
import Table from "../../Components/Table";
import { deleteScholarshipMappingById, getScholarshipMapping } from "../../Services/MasterService";

const ScholarshipsMapping = () => {
    const columns = [
        {
            value: "scholarship_name",
            label: "Scholarship"
        },
        {
            value: "entity",
            label: "Entity"
        },
        {
            value: "entity_id",
            label: "Entity ID"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddScholarshipMapping data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getScholarshipMapping}
            columns={columns}
            title={"Scholarships Mapping"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteScholarshipMappingById}
            disableEdit={true}
        />
    );
}

export default ScholarshipsMapping;